import { DateTime } from 'luxon';
import { TimeZone } from '../data/models/timezone.model';

class DateUtils {
  // public readonly WORK_TIME_ZONE = 'America/Los_Angeles';

  public getTimeZoneIana(timezones: TimeZone[], timeZoneId: number): string {
    const tz = timezones.find((t) => t.timeZoneID === timeZoneId);
    return tz?.ianaStandard || '';
  }

  public formatTime(dateTime: DateTime) {
    return dateTime ? dateTime.toFormat('hh:mm a') : '';
  }

  public formatDate(dateTime: DateTime) {
    return dateTime ? dateTime.toFormat('MM/dd/yyyy') : '';
  }

  public formatDateTime(dateTime: DateTime) {
    return dateTime ? dateTime.toLocaleString(DateTime.DATETIME_SHORT) : '';
  }

  public formatAppointmentDate(
    appointmentDate: string | null | undefined,
    timeZone: string,
  ) {
    if (appointmentDate) {
      return DateTime.fromISO(appointmentDate, {
        zone: timeZone,
      }).toLocaleString(DateTime.DATE_SHORT);
    }
  }

  public formatPickupDate(
    pickupDateTime: string | null | undefined,
    timeZone: string,
  ) {
    if (pickupDateTime) {
      return this.formatDate(
        DateTime.fromISO(pickupDateTime, { zone: timeZone }),
      );
    }
    return '';
  }

  public formatPickupTime(
    pickupDateTime: string | null | undefined,
    timeZone: string,
  ) {
    if (pickupDateTime) {
      return this.formatTime(
        DateTime.fromISO(pickupDateTime, { zone: timeZone }),
      );
    }
    return '';
  }

  public formatPickupDateTime(
    pickupDateTime: string | null | undefined,
    timeZone: string,
  ) {
    if (pickupDateTime) {
      return this.formatDateTime(
        DateTime.fromISO(pickupDateTime, { zone: timeZone }),
      );
    }
    return '';
  }
}

const dateUtils = new DateUtils();

export default dateUtils;
